import { useQuery } from '@tanstack/react-query';

import { BaseError } from '../../helpers/BaseError';

import {
    ContactUserTokenFilterParams,
    GroupTestMessageSettingModal,
} from '../../models/contact_notification_token';

import API from '../../services/api';

import testMessageSettingUserKeys from './_querykeys';

const getGroupTestMessageUsers = async (
    filterParams?: ContactUserTokenFilterParams,
) => {
    const { data } = await API.getGroupTestMessageUsers(filterParams);
    return data as GroupTestMessageSettingModal[];
};

export default function useGetGroupTestMessageUsers(
    filterParams?: ContactUserTokenFilterParams,
    enabled?: boolean,
) {
    return useQuery<GroupTestMessageSettingModal[], BaseError>({
        queryKey: testMessageSettingUserKeys.groupTestMessageUser,
        queryFn: () => getGroupTestMessageUsers(filterParams),
        enabled: enabled,
    });
}
